import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { AND, XIF } from '../utils/excel-functions-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';


export const derDraftel_terkk_parniovlazivac_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state(),
    // ksirinaoznaka: virtel_k.ksirinaoznaka,
    // kvisinaoznaka: virtel_k.kvisinaoznaka,
    vrstaprofila: virtel_m.vrstaprofila,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
    "_extra_siframodula": null, // NOVO 2025-03-18
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_parniovlazivac_izracunaj_materijale = (pods_input, cparams_combined, state) => {
  //
  // const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  /*
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  */
  //
  const pov_materijal_lim = _cpci.pov_materijal_lim;
  const pov_materijal_sipka_navojna = _cpci.pov_materijal_sipka_navojna;
  const pov_materijal_cev = _cpci.pov_materijal_cev;
  //
  return {
    // tipmetalalima,
    pov_materijal_lim,
    pov_materijal_sipka_navojna,
    pov_materijal_cev,
  };
};


//
export const derivatPoluproizvod_parniovlazivac_naziv = (tip, duzina) => {
  let naziv = '???';

  return naziv;
};


//
export const _derivat_terkk_parniovlazivac_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  /*
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  */
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
    tervrstaprofila_50_ili_70,
    //
    pov_materijal_lim,
    pov_materijal_sipka_navojna,
    pov_materijal_cev,
    //
    kolicina,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    /*
    if (family === 'terkk$pov/SKLOP_POV') {
      item.distinction_key = "terkk$POV/SKLOP_POV"; // DIRTY
      item.naziv = "SKLOP PARNI OVLAZIVAC"; // DIRTY
    }
    */
    //
    if (family === 'terkk$pov/NOSAC_DONJI') {
      item.distinction_key = "terkk$POV/NOSAC_DONJI"; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
    }
    //
    if (family === 'terkk$pov/NOSAC_GORNJI') {
      item.distinction_key = "terkk$POV/NOSAC_GORNJI"; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_parniovlazivac_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    vrstaprofila,
    // msirinaspoljasnja,
    // mvisinaspoljasnja,
    _extra_siframodula,
  } = pods_input;
  const {
    tip, //

    //
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
    //
    pov_materijal_lim,
    pov_materijal_sipka_navojna,
    pov_materijal_cev,
    //
    kolicina,
  } = state;

  //
  let _visina_20_ili_35 = -1;
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  // NJ: Visina omega profila je uvek 20mm ili 35mm zavisno od toga koji profil modula se koristi.
  if (tervrstaprofila_50_ili_70 === '50') {
    _visina_20_ili_35 = 20;
  }
  if (tervrstaprofila_50_ili_70 === '70') {
    _visina_20_ili_35 = 35;
  }

  // TODO
  const protobomp_superdata = {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
    tervrstaprofila_50_ili_70,
    //
    pov_materijal_lim,
    pov_materijal_sipka_navojna,
    pov_materijal_cev,
    //
    kolicina,
    _extra_siframodula, //
  };

  const B8 = tip;
  const C8 = "06"; // TODO
  const F8 = kolicina;
  let a = 0;

  /*
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(termaterijal);
  const _tipmetalalima = _mat_params.naziv_materijala;
  const F7 = _tipmetalalima;
  */

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$pov"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_parniovlazivac_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  // NJ: Ovde nemamo sklop svaki element ide bez sklopa i identa, što sam i napomenuo "Ovde u protobom imamo sledeće stavke, bez sklopa".
  /*
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$pov/SKLOP_POV',
    naziv: '* SKLOP PARNI OVLAZIVAC',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_PARNI_OVLAZIVAC');
  const { created_tempkey: sklop_parniovlazivac } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  */
  // NJ: Ovde nemamo sklop svaki element ide bez sklopa i identa, što sam i napomenuo "Ovde u protobom imamo sledeće stavke, bez sklopa".
  const sklop_parniovlazivac = null; // VAZNO laziramo da elementima parent bude protobomp root (null) umesto sklop
  //
  // ----- dodavanje primitivnih u sklopove
  //

  //
  if (true) {

    //
    // 1.Odnosi se na donji nosač navojne šipke.
    if (true) { // if petlja samo zbog scopea promenjivih
      if (true) { // 1) OMEGA

        // Broj Crteža: =IF(F8<>"","P01-27-A","")
        const broj_crteza = XIF(F8 === "", "", "P01-27-A");

        // Ident: =IF(AND(F8<> "",B8="CAREL"),"P01-27-A-"&C8 &"-SS","")
        const ident = XIF(AND(F8 > 0, B8 === "CAREL"), "P01-27-A-" & C8 & "-SS", "");

        const naziv = "OMEGA";

        // Dužina: =IF(F8="","",XLOOKUP(C8,PARAMETRI!$AB$2:$AB$15,PARAMETRI!$AD$2:$AD$15))
        // const duzina = XIF(F8="","",XLOOKUP(C8,PARAMETRI!$AB$2:$AB$15,PARAMETRI!$AD$2:$AD$15))
        const duzina = -1; // TODO

        // Količina, jednaka je količini koju unesemo

        const item = {
          tempkey: 1,
          // tip: "VERTIKALNI_NOSAC_LEVI",
          naziv,
          cnccrtez: broj_crteza,
          ident,
          naziv,
          duzina,
          a,
          kolicina,
        };
        item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
        _arr.push(item);
      }
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$pov/NOSAC_DONJI', // TODO
        identmaterijala: pov_materijal_lim,
        naziv: 'DONJI NOSAC NAVOJNE SIPKE',
      };
      /*
      Dim1: 30
      Dim2: $msirinaunutrasnjaizmedjupregradnih
      Površina: Razvijena 1*Razvijena 2
      Razvijena 1:80
      Razvijena 2: $msirinaunutrasnjaizmedjupregradnih
      */
      item.distinction_key = "terkk$POV/NOSAC_DONJI"; // DIRTY
      item.tip = "CAREL"; // DIRTY
      item.kolicina = kolicina * 1; // DIRTY
      item.dimenzija1 = 30; // DIRTY
      item.dimenzija2 = msirinaunutrasnjaizmedjupregradnih; // DIRTY
      item.razvijenamera1 = 80;
      item.razvijenamera2 = msirinaunutrasnjaizmedjupregradnih; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      item.cnccrtez = "P01-27-A-" + msirinaunutrasnjaizmedjupregradnih + "-P1"; // DIRTY
      //
      item.duzina = item.dimenzija2; // DIRTY
      item.visina = item.dimenzija1; // DIRTY
      //
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_parniovlazivac);
    }
    // 2.Odnosi se na gornji nosač navojne šipke.
    if (true) {
      const item = {
        tempkey: 2,
        pbnode_family: 'terkk$pov/NOSAC_GORNJI', // TODO
        identmaterijala: pov_materijal_lim,
        naziv: 'GORNJI NOSAC NAVOJNE SIPKE',
      };
      /*
      Dim1: 40
      Dim2: 19
      Površina: Razvijena 1*Razvijena 2
      Razvijena 1:69
      Razvijena 2: 30
      */
      item.distinction_key = "terkk$POV/NOSAC_GORNJI"; // DIRTY
      item.tip = "CAREL"; // DIRTY
      item.kolicina = kolicina * 1; // DIRTY
      item.dimenzija1 = 40; // DIRTY
      item.dimenzija2 = 19; // DIRTY
      item.razvijenamera1 = 69;
      item.razvijenamera2 = 30; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      item.cnccrtez = "P01-27-A-P2"; // DIRTY
      //
      item.duzina = item.dimenzija2; // DIRTY
      item.visina = item.dimenzija1; // DIRTY
      //
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_parniovlazivac);
    }
    // 3.Odnosi se na materijal za navojnu šipku
    if (true) {
      if (true) { // 2) Navojna šipka M8
        const naziv = "Navojna šipka M8";

        // Dužina: =IF(F8="","",SWITCH($E8,50,XLOOKUP(D8,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AJ$2:$AJ$10-20),70,XLOOKUP(D8,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AK$2:$AK$10-35) ) )
        // const duzina = XIF(F8="","",SWITCH($E8,50,XLOOKUP(D8,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AJ$2:$AJ$10-20),70,XLOOKUP(D8,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AK$2:$AK$10-35)));

        const duzina = -1; // TODO

        // Količina, jednaka je količini koju unesemo

        const item = {
          tempkey: 2,
          // tip: "VERTIKALNI_NOSAC_LEVI",
          naziv,
          duzina,
          kolicina,
        };
        item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
        _arr.push(item);
      }
      const item = {
        tempkey: 2,
        naziv: "SIPKA NAVOJNA A2 PROHROM M8",
        // pbnode_family: 'terkk$pov/?',
        kolicina: -1, //
        jm: tclocal.JM_M,
        terkategorija: "M",
        identcustom: pov_materijal_sipka_navojna,
      };
      /*
      Količina: IF($vrstaprofila=50) THEN $mvisinaunutrasnjaizmedjupregradnih-20
      ELSE IF($vrstaprofila=70) THEN $mvisinaunutrasnjaizmedjupregradnih-35
      */
      if (tervrstaprofila_50_ili_70 === '50') {
        // _visina_20_ili_35 = 20;
        item.kolicina = kolicina * (mvisinaunutrasnjaizmedjupregradnih - 20);
      }
      if (tervrstaprofila_50_ili_70 === '70') {
        // _visina_20_ili_35 = 35;
        item.kolicina = kolicina * (mvisinaunutrasnjaizmedjupregradnih - 35);
      }
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_parniovlazivac);
    }
    // 4.Odnosi se na materijal za cev FI10
    if (true) {
      if (true) {// 3) Prohromska cev FI10
        const naziv = "Prohromska cev FI10";

        // Dužina: =IF(F8="","",XLOOKUP(C8,PARAMETRI!$AB$2:$AB$15,PARAMETRI!$AD$2:$AD$15-20))
        // const duzina = XIF(F8="","",XLOOKUP(C8,PARAMETRI!$AB$2:$AB$15,PARAMETRI!$AD$2:$AD$15-20));
        const duzina = -1; // TODO
        const G14 = duzina;

        // A: =IF(G14<>"",G14-70,"")
        const a = XIF(G14 > 0, G14 - 70, 0);

        // Količina, jednaka je količini koju unesemo

        const item = {
          tempkey: 3,
          // tip: "VERTIKALNI_NOSAC_LEVI",
          naziv,
          duzina,
          a,
          kolicina,
        };
        item.naziv_materijala = terUtils_get_naziv_materijala_by_ident(item.identmaterijala);
        _arr.push(item);
      }
      const item = {
        tempkey: 3,
        naziv: "CEVNI RAZVOD PROHROM SAVNA CEV FI 10 X 1mm",
        // pbnode_family: 'terkk$pov/?',
        kolicina: kolicina * (msirinaunutrasnjaizmedjupregradnih - 20), //
        jm: tclocal.JM_M,
        terkategorija: "M",
        identcustom: pov_materijal_cev,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_parniovlazivac);
    }
  }
  //
  //
  return {
    svasta: {},
    _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_parniovlazivac_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_parniovlazivac_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_parniovlazivac_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


